const ENVIRONMENTS = [
  {
    environment: 'dev-local',
    hostname: 'localhost'
  },
  {
    environment: 'development',
    hostname: 'dppr-dev.apps.ad.corelogic.asia',
    webSocketPort: 4443
  },
  {
    environment: 'uat',
    hostname: 'dppr-uat.corelogic.asia',
    webSocketPort: 4443
  },
  {
    environment: 'production',
    hostname: 'dppr.corelogic.asia',
    webSocketPort: 4443
  }
]

export { ENVIRONMENTS }
